
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/supportHaaretz",
      function () {
        return require("private-next-pages/supportHaaretz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/supportHaaretz"])
      });
    }
  